<template>
  <el-dialog
    class="threeD-popup"
    :class="device.isMobile ? 'threeD-popup-mobile' : ''"
    :title="dialogTitle || '三维模型'"
    :visible.sync="visible"
    :destroy-on-close="true"
    :append-to-body="true"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="visible"
  >
    <div
      class="threeD-content-box"
      :class="screenType === 'width' ? 'threeD-content-box-width' : screenType === 'height' ? 'threeD-content-box-height' : ''"
      id="iframeBox"
    >
      <div class="threeD-box">
        <iframe :src="iframeUrl" id="iframe" frameborder="0" class="threeD" allowfullscreen="true" width="100%" height="100%" @load="adjustIframe"></iframe>
        <!-- <iframe id="iframe" class="threeD" :src="threeDList[activeIndex].url" marginwidth="0" frameborder="0" :scrolling="iframeScrolling" height="100%"></iframe> -->
      </div>
      <!-- <div class="action-btn">
        <el-button class="btn" type="primary" size="mini" @click="openInNewPage" v-if="showInNewPage">在新页面打开</el-button>
        <el-button class="btn" type="primary" size="mini" @click="openInFullPage" v-if="showInFullPage">全屏查看</el-button>
      </div> -->
      <!-- <div class="close-btn" @click="closeHandle">
        <span class="el-icon-circle-close"></span>
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
/*
三维模型弹窗
*/
export default {
  name: "threeDPopup",
  props: {
    dialogTitle: {
      type: String,
      default: ""
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    iframeUrl: {
      type: String,
      default: ''
    },
    showInNewPage: {
      type: Boolean,
      default: false
    },
    showInFullPage: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    dialogVisible(newVal) {
      this.visible = newVal
      if(newVal) {
        this.$nextTick(() => {
          this.loadIframe();
        })
      }
    }
  },
  data() {
    return {
      visible: false,
      screenType: '',
    }
  },
  methods: {
    loadIframe() {
      // 超长或者超宽的手机屏幕，进行放大的适配
      setTimeout(() => {
        let iframeBox = document.getElementById('iframeBox');
        if(iframeBox) {
          let width = iframeBox.clientWidth;
          let height = iframeBox.clientHeight;

          if(this.device.isMobile && !this.device.isIos && (height / width < 1.1)) {
            this.screenType = 'width'
          }else if(this.device.isMobile && !this.device.isIos && (height / width > 2.2)){
            this.screenType = 'height'
          }
        }else{
          this.loadIframe()
        }
      }, 100)
    },
    closeHandle() {
      this.$emit('dialogClose')
    },
    openInNewPage() {
      window.open(this.iframeUrl)
    },
    openInFullPage() {
      //设置后就是id==inner 的容器全屏
      var fullPage = document.getElementById('iframe')
      if (this.fullscreen) {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
        }
      } else {
        if (fullPage.requestFullscreen) {
          fullPage.requestFullscreen()
        } else if (fullPage.webkitRequestFullScreen) {
          fullPage.webkitRequestFullScreen()
        } else if (fullPage.mozRequestFullScreen) {
          fullPage.mozRequestFullScreen()
        } else if (fullPage.msRequestFullscreen) {
          // IE11
          fullPage.msRequestFullscreen()
        }
      }
    },

    //iframe load事件 适应弹窗的大小
    adjustIframe() {
      return false
      // 同源的iframe可以直接获取内容的document对象，可以直接获取尺寸
      // 非同源需要监听 window.addEventListener 'message' 并在子页面增加方法以获取页面的尺寸
      
      var iframe = document.getElementById('iframe');
      // 获取父级容器的宽高  //也就是弹框在样式中设置的高宽 最好给固定值 在这里可以直接拿到 
      var containerWidth = 1145;
      var containerHeight = 600;


      try {
        // 对于同源iframe，可以直接访问内容Document对象
        var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        console.log(iframeDoc)
        // 获取iframe内容的宽度和高度
        var contentWidth = iframeDoc.body.scrollWidth;
        var contentHeight = iframeDoc.body.scrollHeight;
      } catch(e) {

        console.log(e)
      }
      
      
      console.log('iframe content size: width=' + contentWidth + ', height=' + contentHeight);
      return

      // 计算缩放比例  
      var scaleWidth = containerWidth / this.previewObj.widthValue;
      var scaleHeight = containerHeight / this.previewObj.heightValue;
      var scale = Math.min(scaleWidth, scaleHeight); // 选择较小的缩放比例以保持宽高比  

      // 应用缩放和定位  
      iframe.style.transformOrigin = 'top left';
      iframe.style.transform = `scale(${scale}) translate(-50%, -50%)`;

      // 如果需要，可以调整iframe的宽高以匹配容器  
      // 但由于我们使用了scale，所以通常不需要这样做  
      iframe.style.width = `${this.previewObj.widthValue}px`;
      iframe.style.height = `${this.previewObj.heightValue}px`;
    },
  }
}
</script>

<style lang="scss" scoped>
.threeD-popup{
  text-indent: 0;
  text-align: center;

  /deep/.el-dialog{
    height: 85%;
    .el-dialog__header{
      text-align: left;
    }
  }
  
  .threeD-content-box{
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: hidden;

    .threeD-box{
      width: 100%;
      height: 100%;
      transform-origin: top center;
      transform: scale(0.5);
      position: relative;

      .threeD{
        width: 100%;
        padding: 0;
        width: 200%;
        height: 200%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .action-btn{
      position: absolute;
      bottom: 50rem;
      right: 30rem;
      width: 180rem;
      

      .btn{
        margin: 0 auto;
        margin-bottom: 30rem;
      }
    }
  }
}
.threeD-popup-mobile{
  .content-box{
    .list-box{
      .threeD-item{
        .item-title{
          font-size: 20rem;
        }
      }
    }
    
    .action-btn{
      bottom: 30rem;
      width: 200rem;
    }
  }
  .threeD-content-box-width{
    .threeD-box{
      .threeD{
        width: 120%;
      }
    }
  }
  .threeD-content-box-height{
    .threeD-box{
      .threeD{
        height: 160%;
      }
    }
  }
}
</style>